export default __webpack_public_path__ + "static/media/calendar-icon.55318fa1.svg";